import { render, staticRenderFns } from "./cpt-dataV-decoration.vue?vue&type=template&id=a1a1158c&scoped=true"
import script from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a1158c",
  null
  
)

export default component.exports